export const ProtectedRoute = ({ children }) => {
  return children
}
